module.exports = __webpack_public_path__ + "img/2.516563e0.png";